
define('inlineSvg!svgs/icon/share-facebook', function () {return '<span class="inline-share-facebook inline-icon"><svg width="32" height="32" viewBox="-2 -2 32 32"><path d="M17.9 14h-3v8H12v-8h-2v-2.9h2V8.7C12 6.8 13.1 5 16 5c1.2 0 2 .1 2 .1v3h-1.8c-1 0-1.2.5-1.2 1.3v1.8h3l-.1 2.8z"/></svg></span>';});

